import dynamic from 'next/dynamic'

export const DynamicCore = dynamic(() => import('./index'), {
  ssr: false,
})
